import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getAppId, getEmail, getEmergenceInfo,setDeclarationInfo, getStageID, set1BpersonalInfo, setAddressInfo, setParentInfo, setTravelInfo, setTStageID } from "../utility/Common";
import Header from "./layout/Header";
import NavBar_appID from "./layout/NavBar_appID";
import Footer from "./layout/Footer";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { createNotification } from "./Popup";
import { applicationManagementMasilingi } from "../utility/services/apiService";
import { messages } from "../utility/services/message";
import CentryReusableComponent from "./CentryReusableComponent";

function Step_five() {
  let navigate = useNavigate();
  const emergencyInfoData = useLocation();
  //var Stage = emergencyInfoData.state?.DocStageID;
  var Stage = +getStageID()
  const [isValidLingth, setIsValidLength] = useState(false);
  const [isValidLingth2, setIsValidLength2] = useState(false);
  const [ZanzibarID, setZanzibarID] = useState("");
  const [BirthWardID, setBirthWardID] = useState("");
  const [AnyOtherID, setAnyOtherID] = useState("");
  const [BirthVillage, setBirthVillage] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [phoneError2, setPhoneError2] = useState("");

  const [FatherFullName, setFatherFullName] = useState("");
  const [MotherFullName, setMotherFullName] = useState("");
  const [FatherDOB, setFatherDOB] = useState("");
  const [MotherDOB, setMotherDOB] = useState("");
  const [FatherDistrictID, setFatherDistrictID] = useState("");
  const [MotherDistrictID, setMotherDistrictID] = useState("");
  const [FatherWard, setFatherBirthWardID] = useState([]);
  const [MotherWard, setMotherBirthWardID] = useState([]);
  const [FatherVillage, setFatherVillage] = useState("");
  const [MotherVillage, setMotherVillage] = useState("");

  const [TravelPurposeID, setTravelPurposeID] = useState("");
  const [VisitCountryID, setVisitCountryID] = useState("");
  const [GuardianFullName, setGuardianFullName] = useState("");
  const [GuardianJob, setGuardianJob] = useState("");
  const [GuardianBox, setGuardianBox] = useState("");
  const [GuardianPhoneNumber, setGuardianPhoneNumber] = useState("");
  const [GuardianRelationShip, setGuardianRelationShip] = useState("");
  const [occupatinID, setOccupationID] = useState([]);
  const { checkApplicationStage } = CentryReusableComponent({});
  const [FirstContactName, setFirstContactName] = useState("");
  const [FirstContactWorkID, setFirstContactWorkID] = useState("");
  const [FirstContactBox, setFirstContactBox] = useState("");
  const [FirstContactPhoneNo, setFirstContactPhoneNo] = useState("");
  const [FirstContactTown, setFirstContactTown] = useState("");
  const [FirstContactStreet, setFirstContactStreet] = useState("");
  const [FirstContactHouseNumber, setFirstContactHouseNumber] = useState("");
  const [FirstContactRelationship, setFirstContactRelationship] = useState("");
  const [SecondContactName, setSecondContactName] = useState("");
  const [SecondContactWorkID, setSecondContactWorkID] = useState("");
  const [SecondContactBox, setSecondContactBox] = useState("");
  const [SecondContactPhoneNo, setSecondContactPhoneNo] = useState("");
  const [SecondContactTown, setSecondContactTown] = useState("");
  const [SecondContactStreet, setSecondContactStreet] = useState("");
  const [isLoading,setIsLoading]=useState(false)
  const [SecondContactHouseNo, setSecondContactHouseNo] = useState("");
  const [SecondContactRelationship, setSecondContactRelationship] =
    useState("");
  const [stageID, setStageID] = useState(null);

  //======Lookups test
  useEffect(() => {
    setEmergencyInfo();
  }, []);

  const setEmergencyInfo = () => {
    checkApplicationStage(2)
    // const data = emergencyInfoData?.state;
    const data = getEmergenceInfo()
    if (data) {
      console.log(data)
      setFirstContactName(data?.E1FullName || "");
      setFirstContactWorkID(data?.E1Job || "");
      setFirstContactBox(data?.E1Box || "");
      setFirstContactPhoneNo(data?.E1PhoneNumber || "");
      setFirstContactTown(data?.E1City || "");
      setFirstContactStreet(data?.E1Street || "");
      setFirstContactHouseNumber(data?.E1HouseNo || "");
      setFirstContactRelationship(data?.E1RelationShip || "");
      setFirstContactRelationship(data?.E1RelationShip || "");
      setSecondContactName(data?.E2FullName || "");
      setSecondContactWorkID(data?.E2Job || "");
      setSecondContactBox(data?.E2Box || "");
      setSecondContactPhoneNo(data?.E2PhoneNumber || "");
      setSecondContactTown(data?.E2City || "");
      setSecondContactStreet(data?.E2Street || "");
      setSecondContactHouseNo(data?.E2HouseNo || "");
      setSecondContactRelationship(data?.E2RelationShip || "");
    }
  };

  const validatePhoneNumber = (phoneNumber) => {
    const parsedNumber = parsePhoneNumberFromString(`+${phoneNumber}`, "TZ");
    if (!parsedNumber || !parsedNumber.isValid()) {
      return "Simu ya mkononi si sahihi.";
    }
    return "";
  };

  const handlePhoneInputChange = (setter, phoneNumber) => {
    setter(phoneNumber);
    const error = validatePhoneNumber(phoneNumber);
    setPhoneError(error);
    setPhoneError2(error);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if ((phoneError, phoneError2)) {
      createNotification({ type: "error", message: phoneError })();
      return;
    }

    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: Stage == 250 ? "Insert" : "Update",
      FirstContactName,
      FirstContactWorkID,
      FirstContactBox,
      FirstContactPhoneNo,
      FirstContactTown,
      FirstContactStreet,
      FirstContactHouseNumber,
      FirstContactRelationship,
      SecondContactName,
      SecondContactWorkID,
      SecondContactBox,
      SecondContactPhoneNo,
      SecondContactTown,
      SecondContactStreet,
      SecondContactHouseNo,
      SecondContactRelationship,
    };
    const navigateToStage = (stage, message) => {
      const routes = {
        250: "/stp5",
        260: "/stp6",
        270: "/stp7",
      };
      navigate(routes[stage] || "/continue");
      // createNotification({ type: "success", message })();
    };
    applicationManagementMasilingi(formData, "add-emergency-info")
      .then(async (result) => {
        if (result.code == 1) {
         await goToDeclaration()
          if (result.data) {
            const stID = result?.data[0]?.StageID
            setTStageID(stID)
          }
          if (Stage == 250 && formData.Action == "Insert") {

            navigate("/stp6");
          } else if (Stage == 260 && formData.Action == "Update") {
            navigate("/stp6");
          } else {
            navigateToStage(Stage, result.message);
          }
          setStageID(result?.data[0]?.StageID);
          createNotification({ type: "success", message: result.message })();
        } else if (
          result.code == 3 ||
          result.message.toLowerCase().includes("expire")
        ) {
          createNotification({
            type: "error",
            message: "Session expired. Please log in again.",
          })();
          navigate("/");
        } else {
          createNotification({ type: "error", message: result.message })();
        }
      })
      .catch(() => {
        createNotification({ type: "error", message: messages.networkError })();
      });
  };

  const endeleaBadae = () => {
    navigate("/");
  };

  //--------------------BackStage
  const handleBackStep = (endpoint, formData, routes) => {
    try {
      applicationManagementMasilingi(formData, endpoint).then((result) => {
        if (
          result.code == 3 ||
          result.message?.toLowerCase().includes("expire")
        ) {
          createNotification({ type: "error", message: "Session expired" })();
          navigate("/");
        } else if (result.code == 1 && result.data.length > 0) {
          if (endpoint == "add_missing_personal_info") {
            set1BpersonalInfo(result?.data[0])
          } else if (endpoint == "add-address-info") {
            setAddressInfo(result.data[0])
          } else if (endpoint == "add-parents-info") {
            setParentInfo(result.data[0])
          } else if (endpoint == "add-travel-info") {
            setTravelInfo(result.data[0])
          }
          const applicationFrom = result?.data[0]?.ApplicationFrom;
          const navigatePath = routes[applicationFrom] || routes.default;

          if (navigatePath) {
            navigate(navigatePath, { state: result?.data[0] });
          } else {
            const info = { type: "error", message: result.message };
            createNotification(info)();
          }
        } else {
          const info = { type: "error", message: result.message };
          createNotification(info)();
        }
      });
    } catch (error) {
      const info = { type: "error", message: messages.networkError };
      createNotification(info)();
    }
  };

  const backStp1 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      BirthVillage,
      BirthWardID,
      ZanzibarID,
      AnyOtherID,
    };

    const routes = {
      3: "/stp1B",
      4: "/stp1",
      5: "/stp1",
      default: null,
    };

    handleBackStep("add_missing_personal_info", formData, routes);
  };

  const backStp2 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      HouseNumber: "",
      ResidenceDistrictID: "",
      ResidenceVillage: "",
    };

    const routes = {
      default: "/stp2",
    };

    handleBackStep("add-address-info", formData, routes);
  };

  const backStp3 = () => {
    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: "Select",
      ResidenceDistrictID: "",
      ResidenceVillage: "",
      HouseNumber: "",
      FatherFullName,
      FatherDOB,
      FatherDistrictID,
      FatherWard,
      FatherVillage,
      MotherFullName,
      MotherDOB,
      MotherDistrictID,
      MotherWard,
      MotherVillage,
    };

    const routes = {
      default: "/stp3",
    };

    handleBackStep("add-parents-info", formData, routes);
  };

  const backStp4 = () => {
    const formData = {
      ApplicationId: getAppId(),
      TravellingPurposeID: TravelPurposeID,
      CountryID: VisitCountryID,
      OccupationID: occupatinID,
      EmailAddress: getEmail(),
      Action: "Select",
      GuardianFullName,
      GuardianJob,
      GuardianBox,
      GuardianPhoneNumber,
      GuardianRelationShip,
    };

    const routes = {
      default: "/stp4",
    };

    handleBackStep("add-travel-info", formData, routes);
  };
  const goToDeclaration = async () => {
      const formData = {
        ApplicationId: getAppId(),
        EmailAddress: getEmail(),
        Action: "Normal",
      };
  
      try {
        const result = await applicationManagementMasilingi(
          formData,
          "declaration",
        );
        if (result.code == 1 && result.data) {
          setDeclarationInfo(result.data);
        } 
      } catch (error) {
        const msg =
          error?.response?.data?.message ||
          "Network Error. Please try again later.";
        createNotification({ type: "error", message: msg })();
      } finally {
      
      }
    };
  return (
    <>
      <Header />
      <div className="container">
        <NavBar_appID />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 tab-registration-menu hidden-xs">
                <div className="list-group">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp1();
                    }}
                    className="list-group-item done"
                  >
                    Habari Binafsi{" "}
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp2();
                    }}
                    className="list-group-item done"
                  >
                    Anuwani ya Makazi
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp3();
                    }}
                    className="list-group-item done"
                  >
                    Habari za Wazazi{" "}
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      backStp4();
                    }}
                    className="list-group-item done"
                  >
                    Habari za Safari
                  </Link>
                  <Link to="#" className="list-group-item active">
                    Wakati wa Dharura
                  </Link>
                  <Link className="list-group-item ">Viambatanisho </Link>
                  <Link className="list-group-item ">Tamko Rasmi </Link>
                  <Link className="list-group-item ">Malipo </Link>
                </div>
              </div>
              <div
                className="col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-registration-tab"
                style={{ marginTop: "1px", paddingRight: "1px" }}
              >
                <div className="tab-registration-content active">
                  <form id="step-five-form" onSubmit={handleSubmit}>
                    <div className="box box-default">
                      <div className="box-header with-border">
                        <h3 className="box-title">
                          Mtu wa Kwanza wakati wa Dharura
                        </h3>
                      </div>
                      <div className="box-body" style={{ display: "block" }}>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Jina Kamili
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="FirstContactName"
                                value={FirstContactName}
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z '-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setFirstContactName(value);
                                  }
                                }}
                                required
                              />
                              <p className="help-block help-block-error"></p>
                            </div>{" "}
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Kazi</label>
                              <input
                                type="text"
                                className="form-control"
                                name="FirstContactWorkID"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z ]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setFirstContactWorkID(value);
                                  }
                                }}
                                value={FirstContactWorkID}
                                required
                              />
                              <p className="help-block help-block-error"></p>
                            </div>{" "}
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="control-label">
                                Sanduku la Posta
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="FirstContactBox"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z0-9 ,-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setFirstContactBox(value);
                                  }
                                }}
                                value={FirstContactBox}
                                aria-required="true"
                              />
                              <p className="help-block help-block-error"></p>
                            </div>{" "}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Simu ya Mkononi
                              </label>
                              <div>
                                <PhoneInput
                                  country={"tz"}
                                  value={FirstContactPhoneNo}
                                  onChange={(phone) =>
                                    handlePhoneInputChange(
                                      setFirstContactPhoneNo,
                                      phone
                                    )
                                  }
                                  inputStyle={{ width: "100%" }}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Mji</label>
                              <input
                                type="text"
                                className="form-control"
                                name="FirstContactTown"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z ]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setFirstContactTown(value);
                                  }
                                }}
                                value={FirstContactTown}
                                required
                              />
                              <p className="help-block help-block-error"></p>
                            </div>{" "}
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Mtaa</label>
                              <input
                                type="text"
                                className="form-control"
                                name="FirstContactStreet"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z '-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setFirstContactStreet(value);
                                  }
                                }}
                                value={FirstContactStreet}
                                required
                              />
                              <p className="help-block help-block-error"></p>
                            </div>{" "}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="control-label">
                                Nyumba Na.
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="FirstContactHouseNumber"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z0-9 -]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setFirstContactHouseNumber(value);
                                  }
                                }}
                                value={FirstContactHouseNumber}
                                aria-required="true"
                              />
                              <p className="help-block help-block-error"></p>
                            </div>{" "}
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Uhusiano</label>
                              <input
                                type="text"
                                className="form-control"
                                name="FirstContactRelationship"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z ]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setFirstContactRelationship(value);
                                  }
                                }}
                                value={FirstContactRelationship}
                                required
                              />
                              <p className="help-block help-block-error"></p>
                            </div>{" "}
                          </div>
                          <div className="col-md-4"></div>
                        </div>
                      </div>
                    </div>
                    <div className="box box-default" id="secondcontact">
                      <div className="box-header with-border">
                        <h3 className="box-title">
                          Mtu wa Pili wakati wa Dharura
                        </h3>
                      </div>
                      <div className="box-body" style={{ display: "block" }}>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="SecondContactName"
                              >
                                Jina Kamili
                              </label>
                              <input
                                type="text"
                                id="SecondContactName"
                                className="form-control"
                                name="SecondContactName"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z '-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setSecondContactName(value);
                                  }
                                }}
                                value={SecondContactName}
                                required
                              />
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Kazi</label>
                              <input
                                type="text"
                                id="SecondContactWorkID"
                                className="form-control"
                                name="SecondContactWorkID"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z ]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setSecondContactWorkID(value);
                                  }
                                }}
                                value={SecondContactWorkID}
                                required
                              />
                              <p className="help-block help-block-error"></p>
                            </div>{" "}
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="control-label"
                                htmlFor="SecondContactBox"
                              >
                                Sanduku la Posta
                              </label>
                              <input
                                type="text"
                                id="SecondContactBox"
                                className="form-control"
                                name="SecondContactBox"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z0-9 ,-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setSecondContactBox(value);
                                  }
                                }}
                                value={SecondContactBox}
                                aria-required="true"
                              />
                              <p className="help-block help-block-error"></p>
                            </div>{" "}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Simu ya Mkononi
                              </label>
                              <div>
                                <PhoneInput
                                  country={"tz"}
                                  value={SecondContactPhoneNo}
                                  onChange={(phone) =>
                                    handlePhoneInputChange(
                                      setSecondContactPhoneNo,
                                      phone
                                    )
                                  }
                                  inputStyle={{ width: "100%" }}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="SecondContactTown"
                              >
                                Mji
                              </label>
                              <input
                                type="text"
                                id="SecondContactTown"
                                className="form-control"
                                name="SecondContactTown"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z ,-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setSecondContactTown(value);
                                  }
                                }}
                                value={SecondContactTown}
                                required
                              />
                              <p className="help-block help-block-error"></p>
                            </div>{" "}
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="SecondContactStreet"
                              >
                                Mtaa
                              </label>
                              <input
                                type="text"
                                id="SecondContactStreet"
                                className="form-control"
                                name="SecondContactStreet"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z ,-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setSecondContactStreet(value);
                                  }
                                }}
                                value={SecondContactStreet}
                                required
                              />
                              <p className="help-block help-block-error"></p>
                            </div>{" "}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="control-label"
                                htmlFor="SecondContactHouseNo"
                              >
                                Nyumba Na.
                              </label>
                              <input
                                type="text"
                                id="SecondContactHouseNo"
                                className="form-control"
                                name="SecondContactHouseNo"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z0-9 -]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setSecondContactHouseNo(value);
                                  }
                                }}
                                value={SecondContactHouseNo}
                                aria-required="true"
                              />
                              <p className="help-block help-block-error"></p>
                            </div>{" "}
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Uhusiano</label>
                              <input
                                type="text"
                                id="SecondContactRelationship"
                                className="form-control"
                                name="SecondContactRelationship"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z ]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setSecondContactRelationship(value);
                                  }
                                }}
                                value={SecondContactRelationship}
                                required
                              />
                              <p className="help-block help-block-error"></p>
                            </div>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="box-footer">
                      <div className="row">
                        <div className="col-md-4">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              backStp4();
                            }}
                            className="btn btn-default btn-block btn-label-next"
                            name="SaveBack"
                          >
                            <i className="fa fa-angle-double-left"></i> | Hatua
                            Iliyotangulia
                          </Link>
                        </div>
                        <div className="col-md-4">
                          <Link
                            className="btn btn-labeled btn-block btn-default"
                            name="SaveExit"
                            onClick={(e) => {
                              e.preventDefault();
                              endeleaBadae();
                            }}
                            disabled={!isValidLingth || !isValidLingth2}
                          >
                            Hifadhi na Toka | <i className="fa fa-save"></i>{" "}
                          </Link>
                        </div>
                        <div className="col-md-4">
                          <button
                            className="btn btn-default btn-block btn-label-next"
                            name="SaveNext"
                          >
                            Hifadhi na Endelea |{" "}
                            <i className="fa fa-angle-double-right"></i>{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Step_five;
